<template>
  <div>
    <b-row :class="compactClass">
      <b-col>
        <NewsWidget :posts="newsPosts" :perPage="newsPostCount" />
      </b-col>
    </b-row>
    <b-skeleton-wrapper :loading="newsPosts === null" :class="expandedClass">
      <template #loading>
        <b-row
          :cols="cols"
          :cols-sm="colsSm"
          :cols-md="colsMd"
          :cols-lg="colsLg"
          :cols-xl="colsXl"
          class="w-100"
        >
          <b-col
            v-for="n in newsPostCount"
            :key="$id('news-post-skeleton-' + n)"
            class="mb-4 d-flex"
          >
            <b-card no-body img-top class="news-post w-100">
              <b-skeleton-img card-img="top" aspect="2:1"></b-skeleton-img>
              <b-card-body>
                <b-skeleton
                  height="1.5em"
                  :width="`${getRndInteger(85, 100)}%`"
                ></b-skeleton>
                <div class="mb-2 d-flex justify-content-between">
                  <b-skeleton
                    height="1.25em"
                    :width="`${getRndInteger(15, 25)}%`"
                  ></b-skeleton>
                  <b-skeleton
                    height="1.25em"
                    :width="`${getRndInteger(15, 25)}%`"
                  ></b-skeleton>
                </div>
                <b-skeleton :width="`${getRndInteger(75, 100)}%`"></b-skeleton>
                <b-skeleton :width="`${getRndInteger(75, 100)}%`"></b-skeleton>
                <b-skeleton :width="`${getRndInteger(75, 100)}%`"></b-skeleton>
                <b-skeleton :width="`${getRndInteger(75, 100)}%`"></b-skeleton>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <b-row
        :class="expandedClass"
        align-v="stretch"
        :cols="cols"
        :cols-sm="colsSm"
        :cols-md="colsMd"
        :cols-lg="colsLg"
        :cols-xl="colsXl"
      >
        <b-col
          v-for="post in newsPosts"
          :key="$id(post.slug)"
          class="mb-4 d-flex"
        >
          <NewsPost :newsPost="post" show-section class="news-post w-100" />
        </b-col>
      </b-row>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import NewsWidget from "@/components/NewsWidget.vue";
import NewsPost from "@/components/NewsPost.vue";

export default {
  components: { NewsPost, NewsWidget },
  name: "Dashboard",
  metaInfo: {
    title: "Dashboard",
  },
  props: {
    cols: {
      required: false,
    },
    colsSm: {
      required: false,
    },
    colsMd: {
      required: false,
    },
    colsLg: {
      required: false,
    },
    colsXl: {
      required: false,
    },
    breakpoint: {
      type: String,
      required: false,
      default: "md",
    },
    newsPosts: {
      required: true,
      validator: (prop) => typeof Array.isArray(prop) || prop === null,
    },
    newsPostCount: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
  computed: {
    username() {
      return this.$store.getters.currentUser;
    },
    compactClass() {
      if (this.breakpoint.toLocaleLowerCase() === "xs") {
        return "d-none";
      }
      return `d-flex d-${this.breakpoint}-none`;
    },
    expandedClass() {
      if (this.breakpoint.toLocaleLowerCase() === "xs") {
        return "d-flex";
      }
      return `d-none d-${this.breakpoint}-flex`;
    },
  },
};
</script>
